<template>
  <div>
    <a-modal :title="title" :visible="isVisible" :dialog-style="{ top: '0' }"
             :bodyStyle="{ padding: '0', backgroundColor: '#f3f3f4' }" :destroyOnClose="true" :maskClosable="false"
             width="100%" @cancel="close" :footer="null">
      <div class="projectDetail">
        <div class="information">
          <a-affix :offset-top="0">
            <div class="inform">
              <div class="titleContent">
                <div class="label">
                  <span class="labelCOlor">供应商：</span>
                  <p class="labelCon">
                    <span class="title">{{ dataValue.companyName }}</span>
                  </p>
                </div>
                <div class="label">
                  <span class="labelCOlor">数据所有人：</span>
                  <p class="labelCon">
                    <span style="color: #333;">{{ dataValue.owner }}</span>
                  </p>
                </div>
                <!-- <div class="label">
                    123
                </div> -->
              </div>
              <div class="money">
                <div>
                  <span class="stage amountColor1">采购总金额</span>
                  <a-tooltip placement="bottomLeft">
                    <template slot="title">
                      <span>123</span>
                    </template>
                    <div class="amountNum">
                      <span class="sign">¥</span>
                      <!-- <span class="first">{{ amount.first }}</span>
                      <span class="last">{{ amount.last && amount.last !== '万' ? '.' : '' }}{{
                          amount.last
                      }}</span> -->
                    </div>
                  </a-tooltip>
                </div>
                <div>
                  <span class="stage amountColor2">采购未付款额</span>
                  <a-tooltip placement="bottomLeft">
                    <template slot="title">
                      <span>123</span>
                    </template>
                    <div class="amountNum">
                      <span class="sign">¥</span>
                      <!-- <span class="first">{{ amount.first }}</span> -->
                      <!-- <span class="last">{{ amount.last && amount.last !== '万' ? '.' : '' }}{{
                          amount.last
                      }}</span> -->
                    </div>
                  </a-tooltip>
                </div>
                <div>
                  <span class="stage amountColor3">采购已付款额</span>
                  <a-tooltip placement="bottomLeft">
                    <template slot="title">
                      <span>123</span>
                    </template>
                    <div class="amountNum">
                      <span class="sign">¥</span>
                      <!-- <span class="first">{{ amount.first }}</span>
                      <span class="last">{{ amount.last && amount.last !== '万' ? '.' : '' }}{{
                          amount.last
                      }}</span> -->
                    </div>
                  </a-tooltip>
                </div>
                <div>
                  <span class="stage amountColor4">采购收票额</span>
                  <a-tooltip placement="bottomLeft">
                    <template slot="title">
                      <span>123</span>
                    </template>
                    <div class="amountNum">
                      <span class="sign">¥</span>
                      <!-- <span class="first">{{ amount.first }}</span>
                      <span class="last">{{ amount.last && amount.last !== '万' ? '.' : '' }}{{
                          amount.last
                      }}</span> -->
                    </div>
                  </a-tooltip>
                </div>
              </div>
              <div class="more">
                <a-button type="primary" icon="bar-chart" @click="clickMore">
                  更多
                </a-button>
              </div>
            </div>
          </a-affix>
        </div>
        <div class="messageInfo">
          <div class="titleBox">
            <div class="title" :style="{ borderBottom: `2px solid ${systemColor}`, color: `${systemColor}` }">
              项目信息
            </div>
          </div>
          <div class="main">
            <a-row class="row" v-for="(item, index) in virtualList" :key="index">
              <a-col v-for="(el, ind) in item" :key="ind" :span="el.span">
                <div class="label">
                  <span class="labelCOlor">{{ el.label }}</span>
                  <span v-if="!el.slot" class="labelContent">{{ dataValue[el.value] }}</span>
                  <span v-else class="labelContent">{{ getDictName(el.slotList, dataValue[el.value])
                                    }}</span>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
        <div class="messageInfo" style="height: 37rem;">
          <div class="titleBox">
            <div class="title" :style="{ borderBottom: `2px solid ${systemColor}`, color: `${systemColor}` }">
              跟单时间线
            </div>
          </div>
          <div class="tabs">
            <a-tabs default-active-key="-1" @change="changeTime">
              <a-tab-pane key="-1" tab="全部">

              </a-tab-pane>
              <a-tab-pane key="0" tab="付款计划">

              </a-tab-pane>
              <a-tab-pane key="1" tab="收票记录">

              </a-tab-pane>
              <a-tab-pane key="2" tab="采购单">

              </a-tab-pane>
              <a-tab-pane key="3" tab="付款记录">

              </a-tab-pane>
              <a-tab-pane key="4" tab="应付金额">

              </a-tab-pane>
            </a-tabs>

          </div>
        </div>
      </div>
    </a-modal>
    <summaryInfo ref="summaryInfo" :dialogVisible="isMore" @close="isMore = false"/>
  </div>
</template>

<script>
import summaryInfo from './summaryInfo.vue'

export default {
  name: 'message',
  components: {summaryInfo},
  props: {
    title: {
      type: String,
      default: '供应商详情'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dictData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.close()
      }
    },
    systemColor () {
      return this.$store.state.setting.color[0]
    }
  },
  data () {
    return {
      isMore: false,
      dataValue: {},
      followData: {},
      virtualList: [
        [
          {
            label: '编号:',
            value: 'upperCustomerId',
            span: 12
          },
          {
            label: '供应商名称:',
            value: 'companyName',
            span: 12
          }
        ],
        [
          {
            label: '联系人:',
            value: 'company',
            span: 12
          },
          {
            label: '手机号:',
            value: 'phone',
            span: 12
          }
        ],
        [
          {
            label: '创建时间:',
            value: 'createTime',
            span: 12
          },
          {
            label: '最后跟踪时间:',
            value: 'updateTime',
            span: 12
          }
        ],
        [
          {
            label: '种类:',
            value: 'customerType',
            span: 12
          },
          {
            label: '未跟踪天数:',
            value: 'content',
            span: 12
          }
        ]
      ]
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    initData (row) {
      this.dataValue = row
      // this.getFollow(row.id)
    },
    clickMore () {
      this.isMore = true
      // this.$nextTick(() => {
      //     this.$refs.summary.initData(this.dataValue.id)
      // })
    },
    getDictName (dictCode, dictValue) {
      let dictName = ''
      if (this.dictData[dictCode] && this.dictData[dictCode].length) {
        this.dictData[dictCode].forEach(item => {
          if (item.dictCode === dictValue) {
            dictName = item.dictName
          }
        })
      }
      return dictName
    },
    changeTime () {

    }
  }
}
</script>

<style lang="less" scoped>
  .ant-modal {
    padding-bottom: 0;
    box-sizing: border-box;

  .ant-modal-content {
    min-height: calc(100vh);
  }

  }

  .paymentcss {
    display: flex;
  }

  .projectDetail {

  .information {

  .inform {
    display: flex;

  .titleContent {
    flex: 3;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 20px;
    box-sizing: border-box;
    background-color: #fff;

  .label {
    display: flex;
    align-items: center;
    margin-bottom: 1em;

  .labelCOlor {
    color: #666;
  }

  .labelCon {
    margin-bottom: 0;

  .title {
    font-size: 16px;
    font-weight: bold;
    margin-right: 10px;
  }

  }

  &
  ::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #666;
    margin-right: 2px;
  }

  }
  }

  .money {
    flex: 2;
    padding: 10px 20px;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;

  .amountNum {
    margin-top: 4px;
    color: #f8ac59;

  .sign {
    font-size: 14px;
    margin-right: 3px;
  }

  .first {
    font-size: 26px;
    font-weight: bold;
  }

  .last {
    font-size: 14px;
  }

  }
  }

  .more {
    flex: 1;
    padding: 10px 20px;
    text-align: right;
    box-sizing: border-box;
    background-color: #fff;
  }

  }
  }

  .messageInfo {
    margin-top: 10px;
    padding: 10px 0;
    background-color: #fff;
    border: 1px solid #ddd;

  .titleBox {
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    border-bottom: 1px dashed #e8e8e8;

  .title {
    height: 42px;
    line-height: 42px;
    padding: 0 10px;
    font-size: 16px;
    font-weight: bold;
  }

  }

  .main {
    width: 100%;

  .row {
    padding: 10px 40px;
    border-bottom: 1px dashed #e8e8e8;

  .label {
    color: #7b7d81;
    vertical-align: middle;
    font-weight: 600;
  }

  .value {
    color: #333;
    vertical-align: middle;
    padding-left: 8px;
  }

  }
  }
  }

  .timeline {
    margin-top: 20px;
    background-color: #fff;

  .timeTitle {
    color: #333;
    font-size: 14px;
    font-weight: bold;
    border-bottom: dashed 1px #e9e9e9;
    line-height: 36px;
    padding-left: 20px;
  }

  .tabs {
    padding: 0 20px 20px;
    box-sizing: border-box;
    position: relative;
    height: 100rem;

  .lis {
    width: 100%;
    padding-left: 16px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;

  .lisType {
    display: inline-block;
    background-color: #999;
    color: #fffdfd;
    padding: 2px 6px;
    font-weight: normal;
    text-align: center;
    border-radius: 0.25em;
    margin-bottom: 10px;
  }

  .nameBox {
    font-size: 12px;
    line-height: 2em;
    color: #666;

  .time {
    color: #999;
  }

  }
  }
  }
  }

  .stage {
    padding: 2px 10px;
    border-radius: 10px;
    margin-right: 10px;
    box-sizing: border-box;

  &
  .stageColor {
    background-color: #1ab394;
    color: #fff;
  }

  &
  .statusColor {
    background-color: #efeff4;
    color: #5e5e5e;
  }

  &
  .amountColor1 {
    border-radius: 4px;
    background-color: #12754f;
    color: #fff;
  }

  &
  .amountColor2 {
    border-radius: 4px;
    background-color: red;
    color: #fff;
  }

  &
  .amountColor3 {
    border-radius: 4px;
    background-color: #fa0cda;
    color: #fff;
  }

  &
  .amountColor4 {
    border-radius: 4px;
    background-color: rgb(8, 245, 8);
    color: #fff;
  }

  }
  }

  .ant-tabs-content {
    padding-left: 10px;
  }

  .tabpane1 {
    padding-left: 20px;
  }

  .tabpane2 {
    padding-left: 40px;
  }

  .tabpane3 {
    padding-left: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/views/purchase/supplier/message.vue